import { useMutation } from "@shared/lib/hooks";
import { BriefService } from "../services/brief.service";
import { BRIEF_LIST_QUERY_KEY } from "@entities/brief/lib/constants";
import {
  IBrief,
  IBriefPlanningUpdateRequest,
  IBriefPricingUpdateRequest,
  IBriefUpdateRequest,
} from "@shared/lib/types/brief";
import { ToastService } from "@shared/lib/services";

export function useUpdateBriefPricing() {
  const {
    mutate: updateBriefPricing,
    isLoading: isUpdatingPricing,
    isSuccess: isUpdatedPricing,
    error: updatePricingError,
  } = useMutation({
    mutationFn: ({
      updatedBriefPricing,
    }: {
      updatedBriefPricing: Partial<IBriefPricingUpdateRequest>;
    }) =>
      BriefService.updateBriefPricing(updatedBriefPricing).catch(
        async (err) => {
          const responseBody = await err.response.json();
          ToastService.error(responseBody.msg);
          throw err;
        }
      ),
    options: {},
    onSuccess: (c, _, data) => {
      ToastService.success("Brief Updated Successfully");
      c.invalidateQueries({ queryKey: BRIEF_LIST_QUERY_KEY });
      c.invalidateQueries({
        queryKey: [...BRIEF_LIST_QUERY_KEY, data.updatedBriefPricing.briefId],
      });
    },
  });
  return {
    updateBriefPricing,
    isUpdatingPricing,
    isUpdatedPricing,
    updatePricingError,
  };
}
